import { useShowTutorApi, useAgentsApi } from '@pages/tutor-kanban'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware((to) => {
  const tutorId = to.params.id as string

  void useShowTutorApi({ tutorId })
  void useAgentsApi()
})
